import { render, staticRenderFns } from "./companyProfile.vue?vue&type=template&id=36da7671&scoped=true&"
import script from "./companyProfile.vue?vue&type=script&lang=js&"
export * from "./companyProfile.vue?vue&type=script&lang=js&"
import style0 from "./companyProfile.vue?vue&type=style&index=0&id=36da7671&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36da7671",
  null
  
)

export default component.exports